/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * filtertool-functiealiasregel.ts
 * Gegenereerd met Junie (AI), 01-12-2025
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Subclass voor regels die diensten (planitems) op functionalias filteren.
 */

import {Filtertoolregel} from '../filtertool-regels';
import type { Planitem as PlanitemType } from '../../../models/planitem';
import { PlanitemFilterbareRegel } from '../filtertool-capabilities';

/**
 * Planitemfunctionalias-regel met een lijst van functionalias-waarden. Geldig wanneer er ten minste 1 alias is gekozen.
 */
export class FiltertoolPlanitemfunctiealiasRegel extends Filtertoolregel implements PlanitemFilterbareRegel {
    /** Gekozen functionalias-waarden. */
    functiealiasWaarden: string[];

    constructor(init?: Partial<Filtertoolregel> & { functiealiasWaarden?: string[] }) {
        super('planitemfunctionalias', init as any);
        this.functiealiasWaarden = Array.isArray(init?.functiealiasWaarden) ? init.functiealiasWaarden : [];
    }

    /**
     * Geldig wanneer er minstens één functionalias is gekozen.
     */
    override get valid(): boolean {
        return this.functiealiasWaarden?.length > 0;
    }

    /**
     * Serialiseer inclusief functiealiasWaarden.
     */
    override toObject(): any {
        return {...super.toObject(), functiealiasWaarden: this.functiealiasWaarden || []};
    }

    /**
     * Past de functiealiasregel toe op een planitem.
     * Matcht wanneer het planitem een functionalias heeft die in de lijst voorkomt.
     */
    public filterPlanitem(pi: PlanitemType): boolean {
        if (!pi.functionalias) {
            return false;
        }
        return this.functiealiasWaarden.includes(pi.functionalias);
    }
}
